import { create } from 'zustand';
import { WizardStepEntity } from 'Models/Entities';

export const WizardStepActions = {
	Initiate: 'init',
	Error: 'error',
} as const;

type WizardStepAction =
	| { type: typeof WizardStepActions.Initiate; data: WizardStepEntity[] }
	| { type: typeof WizardStepActions.Error };

interface WizardStepsStore {
	state: 'loading' | 'error' | 'ready';
	wizardSteps: WizardStepEntity[];
	dispatch: (action: WizardStepAction) => void;
}

export const useWizardStepsStore = create<WizardStepsStore>(set => ({
	state: 'loading',
	wizardSteps: [],
	dispatch(action: WizardStepAction) {
		switch (action.type) {
			case WizardStepActions.Initiate: {
				action.data.sort((a, b) => a.order - b.order);
				set({ wizardSteps: action.data, state: 'ready' });
				return;
			}
			case WizardStepActions.Error: {
				set({ state: 'error' });
				return;
			}
			default:
				throw new Error('Action type not supported');
		}
	},
}));
